// eslint-disable-next-line import/no-extraneous-dependencies
// import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

import apiConfig from './ApiConfig';
import {
  CORRELATION_ID_HEADER,
  getStoredCorrelationId,
  storeCorrelationIdFromHeaders
} from '../correlationId';
// import oktaAuth from '../../OktaAuth';
// const baseURL = import.meta.env.VITE_REACT_BACKEND_URL;

// const accessToken = oktaAuth.getAccessToken();

const axiosInstance = axios.create({
  // baseURL,
  headers: {
    'Content-Type': 'application/json'
    // 'ngrok-skip-browser-warning': '69420'
    // Authorization: `Bearer ${accessToken}`,
  }
});

axiosInstance.interceptors.request.use(
  (config) => {
    const correlationId = getStoredCorrelationId();
    if (correlationId) {
      config.headers[CORRELATION_ID_HEADER] = correlationId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    storeCorrelationIdFromHeaders(response.headers);
    return response;
  },
  (error) => {
    storeCorrelationIdFromHeaders(error.response?.headers);
    return Promise.reject(error);
  }
);

const getResponse = (endpoint, params = null, data = null, options = null, raw = false) => {
  let path = '';
  let method = '';
  let multipart = false;
  let baseURL = '';
  let isPublic = false;

  if (typeof endpoint === 'string') {
    baseURL = apiConfig[endpoint].baseURL;
    path = apiConfig[endpoint].path;
    method = apiConfig[endpoint].method;
    multipart = apiConfig[endpoint]?.multipart;
    isPublic = apiConfig[endpoint]?.public;
  } else {
    baseURL = endpoint.baseURL;
    path = endpoint.path;
    method = endpoint.method;
    multipart = endpoint.multipart;
    isPublic = endpoint.public;
  }

  const accessToken = localStorage.getItem('token');

  // Set the Authorization header dynamically (skip for public endpoints)
  let headers = {
    ...axiosInstance.defaults.headers
  };

  if (!isPublic && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  if (multipart) {
    headers = { ...headers, 'Content-Type': 'multipart/form-data' };
  }

  return new Promise((resolve, reject) => {
    const config = {
      baseURL,
      method,
      url: path,
      params,
      headers,
      ...options
    };

    // Always include data if provided (even for GET requests)
    if (data !== null && data !== undefined) {
      config.data = data;
    }

    axiosInstance(config)
      .then((response) => {
        if (raw) {
          resolve(response);
        }
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default getResponse;
